import type { ISerialize } from '@/objects/ISerialize';

export class CategoryTemplate implements ISerialize {
    public ID: number;

    public EventID: number;

    public Name: string | null;

    public SportID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ID?: number; EventID?: number; Name?: string | null; SportID?: number }) {
        this.ID = values.ID ?? 0;

        this.EventID = values.EventID ?? 0;

        this.Name = values.Name ?? null;

        this.SportID = values.SportID ?? 0;
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"EventID": ${JSON.stringify(this.EventID)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            ',' +
            `"SportID": ${JSON.stringify(this.SportID)}` +
            '}'
        );
    }

    /**
     * Creates an instance of CategoryTemplate from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { ID?: number; EventID?: number; Name?: string | null; SportID?: number }): CategoryTemplate {
        return new CategoryTemplate(values);
    }

    public static _FromServerJson(json: any): CategoryTemplate {
        return new CategoryTemplate({ ID: json.ID, EventID: json.EventID, Name: json.Name ?? '', SportID: json.SportID });
    }

    /**
     * Creates an instance of CategoryTemplate from another instance of CategoryTemplate.
     * @param other The CategoryTemplate you want to clone
     * @returns A cloned CategoryTemplate
     */
    public static FromOther(other: CategoryTemplate): CategoryTemplate {
        return CategoryTemplate._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return CategoryTemplate.FromOther(this);
    }

    static NAME_OF_CLASS = 'CategoryTemplate';
}
